/*
 * Tabs script
 */
class Bookero_Tabs {
  constructor () {        
      this.initState();        
      this.initEvents();
  }

  initState () {
      this.wrapper = $('.js-tabs');
      this.tabWrappers = this.wrapper.find('.tablinks-wrapper');
  }

  initEvents () {
    if (this.tabWrappers.length) {
      for (var i = 0; i < this.tabWrappers.length; i++) {
        var tabsID = this.tabWrappers.eq(i).attr('data-id');
        var tabs = this.tabWrappers.eq(i).find('.tablinks');

        for (var j = 0; j < tabs.length; j++) {
          tabs.eq(j).on('click', showTab);
        }
      }
    }
    
    function showTab() {
        var tabsID = $(this).parent().attr('data-id');
        var tabID = $(this).attr('data-id');
        var tabs = $(this).parent().find('.tablinks');
        var tabsContent = $('.tabcontent-wrapper[data-tablinks="' + tabsID + '"]').find('.tabcontent');
    
        $(tabs).each(function(i, tab) {
            if ($(tab).attr('data-id') === tabID) {
                $(tab).addClass('is-active');
            } else {
                $(tab).removeClass('is-active');
            }
        });
    
        tabsContent.each(function(i, content) {
            if ($(content).attr('data-id') === tabID) {
                $(content).addClass('is-active');
            } else {
                $(content).removeClass('is-active');
            }
        });
    }
  }
}